
export type configTypes = "dev" | "staging" | "prod";

/**Sets up the enviroment using enviroment variables */
export const getDynamicEnviroment = (): configTypes => {
    const env = process.env.REACT_APP_ENVIRONMENT as configTypes;
    console.log({ env });
    return env || "dev";
};